
import CommonMixin from '@/mixins/CommonMixin';
import DrawerMixin from '@/components/Common/Mixins/DrawerMixin';

export default {
  mixins: [CommonMixin, DrawerMixin]
};
